import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity'
import { Action, createReducer, on } from '@ngrx/store'

import * as RafflesActions from './raffles.actions'
import { ItemsEntity } from 'libs/gb-dashboard/item/data-access-selected-item/src/lib/+state/selected-item.models'

export const RAFFLES_FEATURE_KEY = 'raffles'

export interface RafflesState extends EntityState<ItemsEntity> {
  selectedId?: string | number
  loaded: boolean
  count: number
}

export interface RafflesPartialState {
  readonly [RAFFLES_FEATURE_KEY]: RafflesState
}

export const rafflesAdapter: EntityAdapter<ItemsEntity> = createEntityAdapter<ItemsEntity>({
  selectId: (item: ItemsEntity) => item.uuid,
})

export const initialRafflesState: RafflesState = rafflesAdapter.getInitialState({
  loaded: false,
  count: 0,
})

const reducer = createReducer(
  initialRafflesState,
  on(RafflesActions.loadRaffles, (state) => ({ ...state, loaded: false })),
  on(RafflesActions.loadRafflesSuccess, (state, action) =>
    rafflesAdapter.setAll(action.items, { ...state, count: action.count, loaded: true }),
  ),
  on(
    RafflesActions.syncRaffleItemSuccess,
    RafflesActions.updateRaffleItemSuccess,
    RafflesActions.concludeRaffleSuccess,
    (state, { update }) => rafflesAdapter.updateOne(update, state),
  ),
  on(RafflesActions.setSelectedRaffleItem, (state, { uuid }) => ({ ...state, selectedId: uuid })),
)

export function rafflesReducer(state: RafflesState | undefined, action: Action) {
  return reducer(state, action)
}
